import {PLACEMENT_TYPES, useHover, useLayer} from 'react-laag';
import {ReactNode} from 'react';
import {a, useTransition} from 'react-spring';
import ResizeObserver from 'resize-observer-polyfill';
import {StyledArrow, TooltipContainer, TooltipLayer} from './Tooltip.styled';
import persistentStore from '@store/persistentStore';
import {Shadow} from '@styles/reusable';

// hacky fix, bc they didn't include placement singlular Types
export type PLACEMENT_TYPE = typeof PLACEMENT_TYPES[number];

const AnimatedTooltip = a(TooltipContainer);

// Gonna disable this for mobile for a while, kinda looks bad

interface TooltipProps {
  children: ReactNode;
  content?: any;
  delayEnter?: number;
  delayLeave?: number;
  offsetY?: number;
  offsetX?: number;
  placement?: PLACEMENT_TYPE;
  className?: string;
  element?: any;
}

export default function Tooltip({
  children,
  content,
  delayEnter = 600,
  delayLeave = 200,
  offsetY = 0,
  offsetX = 0,
  placement,
  className,
  element,
}: TooltipProps) {
  const [isOver, hoverProps] = useHover({ delayEnter: delayEnter, delayLeave: delayLeave });
  const { tooltips } = persistentStore();

  const { triggerProps, layerProps, arrowProps, renderLayer } = useLayer({
    isOpen: isOver,
    placement: placement,
    auto:true,
    ResizeObserver,
  });

  // hiding the initial 0,0 positioning of the tooltip by showing a transition
  const transition = useTransition(isOver, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 150 },
  });

  return (
    <>
      <div {...triggerProps} {...hoverProps} className={className}>
        {children}
      </div>
      {renderLayer(
        <>
          {transition(
            (style, item) =>
              item && (
                <TooltipLayer {...layerProps} offsetY={offsetY} offsetX={offsetX} display={tooltips.toString()}>
                  {content || element ? (
                    <AnimatedTooltip style={style}>
                      {content
                        ? typeof content === 'string'
                          ? content
                          : content.map((item, i) => (
                              <span key={i} style={{ display: 'block'}}>
                                {item}
                              </span>
                            ))
                        : element
                        ? element
                        : null}
                      <StyledArrow {...arrowProps} />
                      <Shadow size={4} />
                    </AnimatedTooltip>
                  ) : null}
                </TooltipLayer>
              ),
          )}
        </>,
      )}
    </>
  );
}
